var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("div", [
      _vm._v("请联系您的毕马威项目经理为您分配KCC站点的权限角色，然后单击"),
      _c("span", { staticClass: "click-pointer", on: { click: _vm.goBack } }, [
        _vm._v("此处"),
      ]),
      _vm._v(
        "重新登录KCC。如有任何问题，请联系毕马威KCC支持团队cnfmkpmgclicbt@kpmg.com！"
      ),
    ]),
    _c("div", [
      _vm._v(
        "Please contact your KPMG engagement manager to assign you with a role within KCC and then login to KCC by clicking "
      ),
      _c("span", { staticClass: "click-pointer", on: { click: _vm.goBack } }, [
        _vm._v("here"),
      ]),
      _vm._v(
        ". Any issues, please contact KCC Help Desk at cnfmkpmgclicbt@kpmg.com!"
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }